import { TemplateElement, html, defineElement, when, optionalAttribute } from '@webtides/element-js';
import style from './section-headline.css';
import '../../../chip/chip.js';

/**
 * @property {KickerProperties} [kicker] - Kicker
 * @property {string} headline - Headline
 * @property {string} [subline] - Optional subline
 */
export default class SectionHeadline extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            kicker: null,
            headline: '',
            subline: '',
        };
    }

    template() {
        return html`
            <div class="flex flex-col items-center">
                ${when(
                    this.kicker && this.kicker.text,
                    html`
                        <mb-chip
                            variant="${this.kicker?.variant || 'gradient'}"
                            text="${this.kicker?.text}"
                            class="mb-fix-2xs md:mb-fix-s mb-chip-size-sm lg:mb-chip-size-md"
                        ></mb-chip>
                    `,
                )}
                <h2
                    class="flex-headline2-medium flex-scale-small text-green-medium text-center text-balance mb-0"
                    ${optionalAttribute(this.kicker?.text, 'aria-label', `${this.kicker?.text} - ${this.headline}`)}
                >
                    ${this.headline}
                </h2>
                ${when(
                    this.subline,
                    html`<p class="flex-headline3-regular flex-scale-small text-center text-balance mb-0">
                        ${this.subline}
                    </p>`,
                )}
            </div>
        `;
    }
}

defineElement('mb-section-headline', SectionHeadline);
